import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";
import { CUSTOM_TRACK_OPTICS_BREAKPOINT_DOWN_410 } from "../../helpers";

export const TRACK_OPTICS_HEADERS_HEIGHT = 166;
export const TRACK_OPTICS_HEADERS_MOBILE_HEIGHT = 212;
export const VIDEO_LIST_WIDTH = 307;

export default makeStyles((theme: MuiTheme) => {
  const {
    palette: { primary },
    breakpoints
  } = theme;

  return {
    videoDetails: {
      width: `calc(100% - ${VIDEO_LIST_WIDTH}px)`,
      maxHeight: `calc(100dvh - ${TRACK_OPTICS_HEADERS_HEIGHT}px)`,
      borderLeft: `1px solid ${primary.light}`,
      backgroundColor: "#fff",
      overflowY: "auto",
      overflowX: "hidden"
    },
    contentWrapper: {
      maxWidth: 1380,
      padding: "10px 37px 32px 40px",
      display: "flex",
      height: "calc(100dvh - 166px)",
      [breakpoints.down(Breakpoints.MD_960)]: {
        display: "block",
        padding: 0
      }
    },
    videoPlayerContainer: {
      display: "flex",
      flexDirection: "column",
      width: "55%",
      marginTop: -4,
      height: "min-content",
      [breakpoints.down(Breakpoints.MD_960)]: {
        width: "100%"
      }
    },
    toggleWrapper: {
      marginTop: 20,
      alignSelf: "flex-end",
      [breakpoints.down(Breakpoints.MD_960)]: {
        marginTop: 18,
        marginRight: 24
      },
      [CUSTOM_TRACK_OPTICS_BREAKPOINT_DOWN_410]: {
        marginRight: 16
      }
    },
    workoutAnalysisContainer: {
      width: "45%",
      padding: "16px 0 0 30px",
      [breakpoints.down(Breakpoints.MD_960)]: {
        width: "100%",
        padding: "0px 24px 30px"
      },
      [breakpoints.down(Breakpoints.SM_600)]: {
        width: "100%",
        padding: "0px 16px 30px"
      }
    },
    workoutAnalysisHeader: {
      fontSize: 16,
      color: "#1a1a1a"
    }
  };
});
